export const markdownInlineComponents = {
  p: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  h1: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  h2: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  h3: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  h4: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  h5: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  h6: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  ul: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  ol: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  li: ({ children }: { children: React.ReactNode }) => <span>{children}</span>,
  blockquote: ({ children }: { children: React.ReactNode }) => (
    <span>{children}</span>
  ),
  code: ({ children }: { children: React.ReactNode }) => (
    <span>{children}</span>
  ),
};
